import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class CO2Emissionsfaktor extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    energie_waermequelle_id: number | null = null;
    faktor: number | null = null;

    // view fields
    energie_waermequelle: string | null = null;
    energie_waermequelle_i18n_key: string | null = null;
    energie_waermequelle_code: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'CO2Emissionsfaktor';
    }
}

export async function createNewCO2Emissionsfaktor(): Promise<CO2Emissionsfaktor> {
    const model = createModel(CO2Emissionsfaktor, {});

    await model.save();
    return model;
}

export class CO2EmissionsfaktorCollection extends BaseCollection<CO2Emissionsfaktor> {
    protected modelCls = CO2Emissionsfaktor;

    public getModelClassName(): string {
        return 'CO2Emissionsfaktor';
    }
}
